var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticStyle:{"flex-wrap":"wrap"}},[_c('div',[_vm._v(" "+_vm._s(_vm.$t("rights_reserved"))+" ")]),_c('v-spacer',{staticClass:"d-none d-md-flex"}),_c('div',[_vm._v("версия "+_vm._s(_vm.$version))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }